module.exports = __webpack_public_path__ + "img/bg-magento-find-out@2x.1f5d0a5e.jpeg";